var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseModal',{staticClass:"whatsapp-popup",class:{ left: _vm.side == 'left' },style:({
      zIndex: _vm.zIndex,
      '--primary-color': _vm.primaryColor,
      '--bottom': _vm.bottom + 'px',
      '--border-radius': _vm.borderRadius + 'px',
      '--svg-size': _vm.svgSize + 'px',
    }),attrs:{"id":`${_vm.$options.name}-${_vm.instanceId}`,"data-module":"whatsapp-popup","show-on-desk":_vm.showOnDesk,"show-on-mobile":_vm.showOnMobile}},[_c('EditorLink',{staticClass:"whatsapp-popup__content",attrs:{"model":_vm.linkUrl}},[_c('IconWhatsApp',{attrs:{"color":"#fff","width":_vm.svgSize,"height":_vm.svgSize}})],1)],1),_c('div',{staticClass:"top-button text-white"},[_c('IconArrow',{attrs:{"direction":"up","size":"md"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }